// extracted by mini-css-extract-plugin
var _1 = "tjs-add-data__dropdown__list";
var _2 = "tjs-add-data__dropdown__list";
var _3 = "tjs-add-data__inner";
var _4 = "tjs-add-data__label tjs-_labels__label";
var _5 = "tjs-add-data__tab-panel";
var _6 = "tjs-add-data__tab-panels";
var _7 = "tjs-add-data__tabHeading";
var _8 = "tjs-add-data__tab-panel";
var _9 = "tjs-add-data__tab-panels";
var _a = "tjs-add-data__url-input";
var _b = "tjs-add-data__url-input__btn tjs-_buttons__btn tjs-_buttons__btn-transparent tjs-_buttons__btn-primary";
var _c = "tjs-add-data__url-input__text-box tjs-_form__field tjs-_form__input";
var _d = "tjs-add-data__url-input";
var _e = "tjs-add-data__url-input__btn tjs-_buttons__btn tjs-_buttons__btn-transparent tjs-_buttons__btn-primary";
var _f = "tjs-add-data__url-input__text-box tjs-_form__field tjs-_form__input";
export { _1 as "dropdownList", _2 as "dropdown__list", _3 as "inner", _4 as "label", _5 as "tab-panel", _6 as "tab-panels", _7 as "tabHeading", _8 as "tabPanel", _9 as "tabPanels", _a as "url-input", _b as "url-input__btn", _c as "url-input__text-box", _d as "urlInput", _e as "urlInputBtn", _f as "urlInputTextBox" }
export default { "dropdownList": _1, "dropdown__list": _2, "inner": _3, "label": _4, "tab-panel": _5, "tab-panels": _6, "tabHeading": _7, "tabPanel": _8, "tabPanels": _9, "url-input": _a, "url-input__btn": _b, "url-input__text-box": _c, "urlInput": _d, "urlInputBtn": _e, "urlInputTextBox": _f }
